import { useEffect, useState } from "react";
import Button from "../../components/Button";
import styled from "styled-components";
import ManageParksHeader from "../../components/ManageParks/ManageParksHeader";
import ParksCardLayout from "../../components/ManageParks/ParksCardLayout";
import { fetchAllParks } from "../../services/parksService";

const ManageParks = () => {
  const [parks, setParks] = useState([]);
  useEffect(() => {
    fetchParks();
  }, []);

  const fetchParks = async () => {
    try {
      let { data } = await fetchAllParks();      
      setParks(data?.data);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <ManageParksHeader />
      <ParksCardLayout parks={parks} />
    </>
  );
};

export default ManageParks;
